import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Cât costă un puț forat?",
    a: "Depinde de adâncime și de localitate. Folosește calculatorul de mai sus pentru o estimare orientativă pe loc — prețul ferm îl stabilim după vizita la teren.",
  },
  {
    q: "Cât durează un foraj?",
    a: "Pentru adâncimile uzuale, de regulă o singură zi de lucru. Durata exactă depinde de tipul de teren și de adâncimea la care găsim pânza de apă.",
  },
  {
    q: "De ce tubulatură albastră cu filet?",
    a: "Țeava PVC albastră cu filet se înșurubează segment cu segment, etanș, fără îmbinări slabe, și este certificată pentru apă potabilă. Este soluția de durată pentru un puț curat mulți ani.",
  },
  {
    q: "Ce adâncime are pânza freatică în Ilfov?",
    a: "Variază mult de la o zonă la alta: de la câțiva metri până la zeci de metri adâncime. Verificăm la fața locului și îți spunem exact ce înseamnă pentru terenul tău.",
  },
  {
    q: "În ce zone lucrați?",
    a: "În toate cele 6 sectoare ale Bucureștiului și în toată județul Ilfov: Otopeni, Voluntari, Corbeanca, Snagov, Buftea, Bragadiru, Pantelimon și alte localități.",
  },
  {
    q: "Ce garanție oferiți?",
    a: "Oferim garanție pe lucrare; condițiile exacte le discutăm transparent la programare, împreună cu tot ce include forajul.",
  },
];

export default function FaqSection() {
  return (
    <section id="intrebari" className="scroll-mt-16 bg-hydro-ice py-24 text-slate-900 md:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-hydro-blue sm:text-xs">
            Întrebări frecvente
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl md:text-6xl">
            Întrebări de la proprietari.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-slate-200 bg-white px-6 last:border-b"
              >
                <AccordionTrigger className="py-5 text-left font-display text-base font-bold hover:no-underline md:text-lg">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-slate-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
